import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CMSForm } from 'src/app/models/form';
import { FormsService } from 'src/app/shared/forms/forms.service';

@Component({
  selector: 'app-new-course',
  templateUrl: './new-course.component.html',
  styleUrls: ['./new-course.component.scss']
})
export class NewCourseComponent implements OnInit {
  title = '';
  closeBtnName = '';
  forms: CMSForm[];
  selectedForm: CMSForm = null;

  constructor(public bsModalRef: BsModalRef, private formsService: FormsService,
    private router: Router) { }

  ngOnInit() {
    this.formsService.getForms().subscribe((res) => { this.forms = res.forms.filter(form => form.active == true) }, (error) => console.error(error));
  }

  create() {
    this.router.navigate(['/courses/edit/0', { type: 'course', form: this.selectedForm.id }]);
    this.bsModalRef.hide();
  }


}
